module.exports = __webpack_public_path__ + "assets/devices/Proxy-tag-70fa9945f714a180738bf7b0bca97d64.svg";